<div
  class="flex w-full"
  [ngClass]="{
    'justify-end': alineamiento == 'der',
    'justify-start': alineamiento == 'izq',
    'justify-center': alineamiento == 'cen'
  }"
>
  <button
    pRipple
    class="bg-primary flex flex-row justify-around transition-all duration-200 items-center shadow-md"
    (click)="onClick()"
    [disabled]="desactivado"
    [ngClass]="{
      'bg-primary/40': desactivado && color == 'primary',
      'bg-secondary-100': desactivado && color == 'secondary',
      'bg-tertiary-100': desactivado && color == 'tertiary',
      'cursor-not-allowed': desactivado,
      'rounded-full': rounded,
      'rounded-xl': !rounded,
      'px-4 py-1': !rounded,
      'p-2': rounded,
      'h-12': alto,
      'bg-primary': color == 'primary',
      'bg-secondary-600': color == 'secondary',
      'bg-tertiary-600': color == 'tertiary'
    }"
  >
    @if(icon) {
    <img src="/svg/{{ icon }}" alt="Icon" width="13" class="blanco mr-1" />
    } @if(!rounded) {
    <p
      class="text-white font-bold"
      [ngClass]="{ 'pr-2': (primeIcon || icon) && !rounded }"
    >
      {{ texto }}
    </p>
    } @if(primeIcon) {
    <i
      class="pi {{ primeIcon }} text-white"
      style="font-size: '{{ !small ? '2rem' : '1rem' }}'"
    ></i>
    }
  </button>
</div>
